import { create } from 'zustand'

interface SidebarStore {
  expanded: boolean
  toggleExpanded: () => void
}

export const useSidebarStore = create<SidebarStore>((set) => ({
  expanded: true,
  toggleExpanded: () => set((state) => ({ expanded: !state.expanded })),
}))
